var run = require('./run'),
    BenchmarkOut = require('./util/benchmark-out'),
    getDefaultOptions = require('./util/get-default-options'),
    multipleBenchmark = require('./util/multi-bench');
/**
 * @method benchmark
 * @description benchmarks gpu.js
 * @param {...Options} options Optional options
 */


var benchmark = function benchmark() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  options = getDefaultOptions(options);
  var out = new BenchmarkOut(true, run(options));
  return out;
};

module.exports = {
  benchmark: benchmark,
  multipleBenchmark: multipleBenchmark
};